import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  getAdminNavTabs,
  superAdminNavOptions,
} from "src/apps/common/menu-navigation/menuNavigation";
import {
  checkViewAccess,
  getActiveApp,
  getActiveView,
  getUserRole,
} from "src/redux/selectors/app";

const useGetNav = () => {
  const activeView = useSelector(getActiveView);
  const activeApp = useSelector(getActiveApp);
  const userRole = useSelector(getUserRole);
  const hasViewAccessToTab = useSelector((state) => checkViewAccess(state));

  const navigationTabs = useMemo(() => {
    if (userRole === 1) {
      return superAdminNavOptions;
    }
    // if (userRole === 2) {
    //   return subAdminNavOptions;
    // }
    return getAdminNavTabs(hasViewAccessToTab, activeApp, activeView);
  }, [userRole, hasViewAccessToTab, activeApp, activeView]);

  return { navigationTabs };
};

export default useGetNav;
